export const config = {
  portfolio: {
    portfolioLogo: 'Rajkamal',
    githubUsername: 'mrCoderPj04',
    profileAvatar: 'https://github.com/mrCoderPj04.png',
    personalInfo: {
      name: 'Rajkamal Singh',
      role: 'Senior AI Engineer & Full-Stack Developer',
      location: 'Chamoli, Uttarakhand, India 🇮🇳',
      email: 'mrcoder04@outlook.com',
      contactEmail: 'rajkamalsingh6959@gmail.com',
      phone: '+91 7060938254',
      github: 'https://github.com/mrCoderPj04',
      linkedin: 'https://www.linkedin.com/in/rajkamal-singh-8693aa2b3/',
      quote: 'Whatever you are doing, do it with absolute dedication and silently; just watch - one day you will become the owner of your dream.',
    },
    projectCard: {
      categories: [
        'All',
        'Full-Stack & Web',
        'Dashboards & ERP',
        'Python & AI',
        'Java & Systems',
        'UI & Utilities',
      ],
      cards: [
        {
          heading: 'JourneyJunction',
          category: 'Full-Stack & Web',
          description:
            'JourneyJunction is a comprehensive travel platform dedicated to discovering the breathtaking beauty and cultural richness of Uttarakhand ("Dev Bhoomi"). Built with TypeScript, React, Node.js, and modern APIs, it features destination guides, trip planning, and personalized recommendations.',
          animationDelay: '100',
          buttonLink: 'https://github.com/mrCoderPj04/JourneyJunction',
          buttonText: 'VIEW REPO',
          language: 'TypeScript / React',
        },
        {
          heading: 'Be_fit',
          category: 'Full-Stack & Web',
          description:
            'A comprehensive fitness & health tracker application helping users achieve wellness goals. Features workout tracking, activity monitoring, meal logging, and progress analytics with insightful visualizations. Built with Vue, Next.js, and Node.js.',
          animationDelay: '200',
          buttonLink: 'https://github.com/mrCoderPj04/Be_fit',
          buttonText: 'VIEW REPO',
          liveLink: 'https://befitpj.netlify.app',
          language: 'Vue / Next.js',
        },
        {
          heading: 'PjStream',
          category: 'Full-Stack & Web',
          description:
            'An innovative media streaming platform bringing movies, TV shows, and video content together. Features responsive media player controls, search indexing, and real-time streaming interfaces built with TypeScript and React.',
          animationDelay: '300',
          buttonLink: 'https://github.com/mrCoderPj04/PjStream',
          buttonText: 'VIEW REPO',
          language: 'TypeScript / React',
        },
        {
          heading: 'PJSOFONIC',
          category: 'Full-Stack & Web',
          description:
            'A modern web platform connecting clients and developers across tech industries. Designed to showcase portfolio services, manage client inquiries, and manage project workflows seamlessly.',
          animationDelay: '400',
          buttonLink: 'https://github.com/mrCoderPj04/PJSOFONIC',
          buttonText: 'VIEW REPO',
          language: 'TypeScript',
        },
        {
          heading: 'Sofo_SyC',
          category: 'Full-Stack & Web',
          description:
            'A full-stack web application suite for system configuration, user access management, and automated web workflows built with JavaScript and Node.js.',
          animationDelay: '500',
          buttonLink: 'https://github.com/mrCoderPj04/Sofo_SyC',
          buttonText: 'VIEW REPO',
          language: 'JavaScript / Node.js',
        },
        {
          heading: 'Sofo_learning',
          category: 'Full-Stack & Web',
          description:
            'An interactive e-learning platform providing course materials, coding tutorials, and progress tracking for student software engineering education.',
          animationDelay: '600',
          buttonLink: 'https://github.com/mrCoderPj04/Sofo_learning',
          buttonText: 'VIEW REPO',
          language: 'TypeScript',
        },
        {
          heading: 'PjDashConnect',
          category: 'Dashboards & ERP',
          description:
            'A powerful and intuitive social media analytics & marketing dashboard developed by Pjsofonic. Provides real-time metrics, cross-platform performance tracking, and centralized social media management.',
          animationDelay: '700',
          buttonLink: 'https://github.com/mrCoderPj04/PjDashConnect',
          buttonText: 'VIEW REPO',
          language: 'TypeScript / React',
        },
        {
          heading: 'pjsofonic-ms-dashboard',
          category: 'Dashboards & ERP',
          description:
            'Microservices management and monitoring dashboard offering health checks, latency visualization, service status logs, and real-time backend analytics.',
          animationDelay: '800',
          buttonLink: 'https://github.com/mrCoderPj04/pjsofonic-ms-dashboard',
          buttonText: 'VIEW REPO',
          liveLink: 'https://pjsofonic-ms-dashboard.vercel.app',
          language: 'TypeScript / Next.js',
        },
        {
          heading: 'PJSPFPNIC_erp',
          category: 'Dashboards & ERP',
          description:
            'Enterprise Resource Planning (ERP) platform designed for business operations management, employee records, inventory tracking, and reporting analytics.',
          animationDelay: '900',
          buttonLink: 'https://github.com/mrCoderPj04/PJSPFPNIC_erp',
          buttonText: 'VIEW REPO',
          language: 'TypeScript',
        },
        {
          heading: 'billl_recipt_genrstor_pyPro',
          category: 'Python & AI',
          description:
            'Automated invoice and receipt generation tool developed in Python. Streamlines billing processes, itemized calculations, tax estimations, and printable PDF receipt creation for retail operations.',
          animationDelay: '1000',
          buttonLink: 'https://github.com/mrCoderPj04/billl_recipt_genrstor_pyPro',
          buttonText: 'VIEW REPO',
          language: 'Python',
        },
        {
          heading: 'App-03',
          category: 'Java & Systems',
          description:
            'An enterprise Java application highlighting modular software design, object-oriented design patterns, robust error handling, and backend service logic.',
          animationDelay: '1100',
          buttonLink: 'https://github.com/mrCoderPj04/App-03',
          buttonText: 'VIEW REPO',
          language: 'Java',
        },
        {
          heading: 'My-cpp-code',
          category: 'Java & Systems',
          description:
            'A comprehensive repository of algorithms, data structures (Trees, Graphs, Dynamic Programming), and system optimization programs implemented in C++.',
          animationDelay: '1200',
          buttonLink: 'https://github.com/mrCoderPj04/My-cpp-code',
          buttonText: 'VIEW REPO',
          language: 'C++',
        },
        {
          heading: 'img-editor',
          category: 'UI & Utilities',
          description:
            'Web-based image editing tool allowing users to apply custom image filters, crop, resize, adjust color balance, and download edited images in real-time.',
          animationDelay: '1300',
          buttonLink: 'https://github.com/mrCoderPj04/img-editor',
          buttonText: 'VIEW REPO',
          language: 'JavaScript',
        },
        {
          heading: 'Chat-box',
          category: 'UI & Utilities',
          description:
            'Responsive real-time chat interface UI component designed with CSS animations, clean layout architecture, and customizable message bubbles.',
          animationDelay: '1400',
          buttonLink: 'https://github.com/mrCoderPj04/Chat-box',
          buttonText: 'VIEW REPO',
          language: 'CSS / Web',
        },
        {
          heading: 'AboutCard',
          category: 'UI & Utilities',
          description:
            'Interactive developer profile card component featuring glowing border effects, hover animations, and custom styling using HTML and CSS.',
          animationDelay: '1500',
          buttonLink: 'https://github.com/mrCoderPj04/AboutCard',
          buttonText: 'VIEW REPO',
          language: 'HTML / CSS',
        },
      ],
    },
    internships: {
      internship: [
        {
          companyName: 'Crossover',
          role: 'Front-end Developer',
          introText:
            'Worked in a high-performance remote-first environment developing scalable frontend interfaces and interactive web components using React, TypeScript, and modern CSS.',
          duration: '29/03/2022 - 29/09/2022',
          keyPointOne:
            'Built responsive front-end web applications using React.js and modern JavaScript.',
          keyPointTwo:
            'Collaborated with global teams to optimize UI performance and accessibility.',
          keyPointThree:
            'Received direct mentorship from senior engineers to master scalable codebase design.',
          keyPointFour:
            'Implemented UI state management and cross-browser responsive layouts.',
          offsetValue: '0',
        },
        {
          companyName: 'TCS iON',
          role: 'FullStack Developer',
          introText:
            'Gained hands-on experience in full-stack web development, working on both client-side user interfaces and server-side APIs.',
          duration: '14/06/2023 - 14/02/2024',
          keyPointOne:
            'Developed robust full-stack web applications using modern React and Node.js frameworks.',
          keyPointTwo:
            'Collaborated with cross-functional teams to build RESTful APIs and database schemas.',
          keyPointThree:
            'Gained proficiency in database management (MongoDB, SQL) and server logic.',
          keyPointFour:
            'Enhanced problem-solving and debugging efficiency across large codebases.',
          offsetValue: '-1000',
        },
        {
          companyName: 'Wipro',
          role: 'JAVA Developer',
          introText:
            'Specialized in Java enterprise software solutions, focusing on backend logic, OOP architecture, and data structures.',
          duration: '13/07/2023 - 15/11/2023',
          keyPointOne:
            'Developed and optimized core backend microservices using Java.',
          keyPointTwo:
            'Enhanced code reliability through unit testing and strict OOP principles.',
          keyPointThree:
            'Collaborated on system performance improvements and database queries.',
          keyPointFour:
            'Leveraged industry-standard version control and build tools.',
          offsetValue: '-1000',
        },
      ],
    },
  },
};

export default config;
